<template>
  <div>
    <div class="vidirect-title">
      <custom-breadcrumb/>
      <div @click="$refs['createVidirect'].showCreateDialog()" class="add-btn">Add New Retailer</div>
    </div>
    <div class="search-box">
      <el-input
        class="search_input"
        v-model="selectData.keyWords"
        prefix-icon="el-icon-search"
        placeholder="Retailer Name/Store Name/Phone/Email/Remark"
        clearable
      />
      <el-button type="primary" class="search-btn" @click="search"
      >Search
      </el-button
      >
    </div>
    <div class="page_table">
      <el-table
        :data="vidirectData"
        stripe
        height="calc(100vh - 300px)"
        style="width: 100%;"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle">
        <el-table-column label="Username" prop="username" width="180" fixed>
        </el-table-column>
        <el-table-column label="Email" prop="email" width="220" fixed style="box-shadow:0 0 10px #06c;">
        </el-table-column>
        <el-table-column label="Store name" prop="storeName" width="150">
        </el-table-column>
        <el-table-column label="Phone" width="150">
          <template slot-scope="scope">
            {{ scope.row.phone }}
          </template>
        </el-table-column>
        <el-table-column label="Address" width="150">
          <template slot-scope="scope">
            {{ scope.row.fulladdress }}
          </template>
        </el-table-column>
        <el-table-column label="Remark1" prop="remark" width="150">
        </el-table-column>
        <!--        <el-table-column label="Contract" width="120" >
                  <template slot-scope="scope">
                    <div class="vidirect-link" @click="downloadFile(scope.row.contract)">{{handleContract(scope.row.contract)}}</div>
                  </template>
                </el-table-column>-->
        <el-table-column label="Total Credit" width="120">
          <template slot-scope="scope">
            ${{ scope.row.totalCredit }}
          </template>
        </el-table-column>
        <!--        <el-table-column label="Brand Credit" width="150" >
                  <template slot-scope="scope">
                    ${{scope.row.exclusiveLimit}}
                  </template>
                </el-table-column>
                <el-table-column label="Brand Credit Available" width="200" >
                  <template slot-scope="scope">
                    ${{scope.row.exclusiveAvailableLimit}}
                  </template>
                </el-table-column>-->
        <el-table-column label="Net terms status" width="180">
          <template slot-scope="scope">
            {{ handleNetTermsStatus(scope.row.netTermStatus) }}
          </template>
        </el-table-column>
        <el-table-column label="Reviewer / Review time" width="200">
          <template slot-scope="scope">
            {{ scope.row.reviewer }}
            <br>
            {{ handleReviewTime(scope.row.reviewTime) }}
          </template>
        </el-table-column>
        <el-table-column label="Bonded Status" width="120">
          <template slot-scope="scope">
            {{ handleBondedStatus(scope.row.isBonded) }}
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :currentPage="selectData.currentPage"
        :total="total"
        :pageSize="selectData.pageSize"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></Pagination>
    </div>
    <create-vidirect ref="createVidirect"></create-vidirect>
  </div>
</template>

<script>
import {getAction, downloadStaticFile} from '@/api/manage.js'
import Pagination from '../components/pagination.vue'
import CreateVidirect from './create-vidirect'
import CustomBreadcrumb from '../components/custom-breadcrumb'

export default {
  components: {CreateVidirect, Pagination, CustomBreadcrumb},
  data() {
    return {
      selectData: {
        currentPage: 1,
        pageSize: 15,
        keyWords: ''
      },
      addressForm: {
        onlineShopType: '',
        storeName: '',
        storeAddress: '',
        state: '',
        city: '',
        zipCode: '',
        source: '',
        webSite: '',
        isGoogleMap: 0,
        country: 'United States of America',
        referCode: ''
      },
      vail: {
        onlineShopTypeError: false,
        storeNameError: false,
        storeAddressError: false,
        stateError: false,
        cityError: false,
        countryError: false,
        zipCodeError: false,
        shopUrlError: false
      },
      vidirectData: [],
      total: 0,
      visible: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.vidirectData = []
      getAction('/sp/suppliers/vidirect', this.selectData).then(response => {
        if (response.success) {
          if (response.result !== null) {
            this.total = response.result.total
            this.selectData.currentPage = response.result.current
            this.selectData.pageSize = response.result.size
            this.vidirectData = response.result.records
            console.log(this.vidirectData, 'ddd')
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    search() {
      this.loadData()
    },
    handleSizeChange(pageSize) {
      this.selectData.pageSize = pageSize
      this.selectData.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(currentPage) {
      this.selectData.currentPage = currentPage
      this.loadData()
    },
    downloadFile(contract) {
      downloadStaticFile(contract).then(response => {
      })
    },
    handleCreditLimit(creditLimit) {
      let value = creditLimit
      const number = Number(value).toLocaleString('en-US')
      return '$' + number
    },
    handleContract(contract) {
      return 'contract' + contract.substring(contract.lastIndexOf('.'), contract.length)
    },
    handleReviewTime(reviewTime) {
      if (reviewTime == null) {
        return
      }
      let monthValue = reviewTime.monthValue.toString()
      let hour = reviewTime.hour.toString()
      let minute = reviewTime.minute.toString()
      let second = reviewTime.second.toString()
      if (monthValue < 10) {
        monthValue = '0' + monthValue
      }
      if (hour < 10) {
        hour = '0' + hour
      }
      if (minute < 10) {
        minute = '0' + minute
      }
      if (second < 10) {
        second = '0' + second
      }
      return reviewTime.year + '/' + monthValue + '/' + reviewTime.dayOfMonth + '  ' + hour + ':' + minute + ':' + second
    },
    handleBondedStatus(isBonded) {
      if (isBonded) {
        return 'Active'
      }
      return 'Inactive'
    },
    handleNetTermsStatus(netTermsStatus) {
      if (netTermsStatus === 'null') {
        return 'Inactive'
      } else if (netTermsStatus === 'inReview') {
        return 'In Review'
      } else if (netTermsStatus === 'declined') {
        return 'Declined'
      } else if (netTermsStatus === 'frozen') {
        return 'Frozen'
      } else if (netTermsStatus === 'completed') {
        return 'Active'
      } else if (netTermsStatus === 'disabled') {
        return 'Disabled'
      }
    },
    headerCellStyle({row, column, rowIndex, columnIndex}) {
      return {
        'text-align': 'left',
        'height': '19px',
        'font-size': '14px',
        'font-family': 'Avenir',
        'font-weight': '500',
        'line-height': '38px',
        'color': '#000000',
        'opacity': 1
      }
    },
    cellStyle({row, column, rowIndex, columnIndex}) {
      return {
        'height': '19px',
        'font-size': '14px',
        'font-family': 'Avenir',
        'font-weight': '500',
        'line-height': '20px',
        'color': '#262B2F',
        'opacity': 1
      }
    },
    addNew() {
      this.$refs['createVidirect'].showCreateDialog()
    }

  }
}
</script>

<style lang="less" scoped>
.search-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin: 40px 0 20px 0;
}

.search-btn {
  background-color: #262b2f;
  border-color: #262b2f;
  width: 100px;
  border-radius: 0;
}

.search_input {
  width: 35%;
}

.page_table {
  width: 100%;
}

.vidirect-title {
  height: 16px;
  font-size: 14px;
  font-weight: 600;
  color: #262B2F;
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 10px !important;
  .add-btn {
    background-color: #262b2f;
    color: #FFFFFF;
    cursor: pointer;
    line-height: 40px;
    height: 40px;
    text-align: center;
    width: 150px;
    font-weight: 500;
  }
}

.vidirect-link {
  height: 19px;
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  line-height: 20px;
  color: #0B8CF4;
  text-decoration: underline;
  opacity: 1;
  cursor: pointer;
}

/* 给固定列设置下边距 */
/deep/ .el-table .el-table__fixed {
  height: auto !important;
  bottom: 16px !important; /* 具体值是多少根据你横向滚动条的高度进行设置 */
}

/* 去掉固定列下方的横线 */
/deep/ .el-table__fixed::before, .el-table__fixed-right::before {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/pages/vidirect/vidirect-list.vue